import React from 'react';
import { withRouter } from 'react-router-dom';
import { Copy, Modal, SystemText } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';

export const Richardson = props => {
    const { data } = props;
    const [show, setShow] = React.useState(false);
    const st = (s, x) => SystemText(`Search/Results/Richardson/${s}`, x);
    const onClick = () => {
        if (data.url) {
            // URL
            window.open(data.url);        
        } else if (data.body) {
            // Text
            setShow(data.body);
        }
    };

    const icon = () => {
        if (data.url) return <i className="fa fa-external-link" />;
    };

    return (
        <>
            <div data-testid="richardson-search" className="search-result box" onClick={onClick}>
                <div className="image-holder hidden-xs">
                    {data.image ? (
                        <BlobImage folder="richardson-thumb" src={data.image} alt="" partnerId="1" />
                    ) : (
                        <img src="/dist/img/accelerate-icon.png" alt="" loading="lazy" />
                    )}
                </div>
                <div>
                    <label className="label label-primary">
                        <i className="mr10 fa fa-pen" />
                        {st('Title')}
                    </label>
                    <h2>
                        {data.name}
                        <span className="ml10">{icon()}</span>
                    </h2>
                    <p>{data.summary}</p>
                </div>
            </div>
            <Modal show={show} close={() => setShow('')} title={data.name} footer={null}>
                <Copy value={show} />
            </Modal>
        </>
    );
};

export default withRouter(Richardson);
